import { render, staticRenderFns } from "./PaginationInfo.vue?vue&type=template&id=b8b5bbd4"
import script from "./PaginationInfo.vue?vue&type=script&lang=js"
export * from "./PaginationInfo.vue?vue&type=script&lang=js"
import style0 from "./PaginationInfo.vue?vue&type=style&index=0&id=b8b5bbd4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports